module.exports = __webpack_public_path__ + "img/WuHan.4cc9f6a1.png";